"use strict";

module.exports = compact;
function compact(arr) {
  return Array.isArray(arr) ? arr.filter(function (i) {
    return i;
  }) : [];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/compact/index.js
// module id = 431
// module chunks = 0